var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxCompletingMilestones01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-completing-milestones-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,9A8,8,0,1,0,6,14.27v9.21l6-2.4,6,2.4V14.27A8,8,0,0,0,20,9ZM12,3A6,6,0,1,1,6,9,6,6,0,0,1,12,3Zm0,15.92-4,1.6v-4.6a7.95,7.95,0,0,0,8,0v4.6Zm0-6.17A3.75,3.75,0,1,0,8.25,9,3.75,3.75,0,0,0,12,12.75Zm0-6A2.25,2.25,0,1,1,9.75,9,2.25,2.25,0,0,1,12,6.75Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxCompletingMilestones01);
export default __webpack_public_path__ + "static/media/24px-completing-milestones-01.0164b171457cd91194613f4e04d57e1f.svg";
export { ForwardRef as ReactComponent };